import React,{useEffect,useState} from 'react'
import { StateUseContext } from '../../context/UserDetailContext';
import {upadateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';

import moment from 'moment';

const ProfileInfoForm = ({nexTabChange}) => {

    const {userDetail,countryCode,setUserDetail} = StateUseContext();
    const {name,email,dob,mobile_no,gender,tshirt_size,target_exam,is_paid,paid_status,country_id,country_code} = userDetail !==undefined && userDetail
    
    const [studentName,setStudentName] = useState({value:'',error:''});
    const [UserEmail,setUserEmail] = useState({value:'',error:''});
    const [userDob,setUserDob] = useState({value:'',error:''});
    const [mobileNumber,setMobileNumber] = useState({value:'',error:''});
    const [UserGender,setUserGender] = useState({value:'',error:''});
    const [tShirtSize,setTshirtSize] = useState({value:'',error:''});
    const [targetExam,setTargetExam] = useState({value:'',options:[],error:''});
    const [loading,setLoading] = useState(false);

    const [userCountryCode,setUserCountryCode] = useState({value:'',error:''});

    const currentDate = moment().format('YYYY-MM-DD');
    const minDate = moment(currentDate).subtract(4, 'years').format('YYYY-MM-DD');

    useEffect(() => {
        if(userDetail !==undefined){
            setStudentName({...studentName,value:name})
            setUserEmail({...UserEmail,value:email})
            setUserDob({...userDob,value:dob})
            setMobileNumber({...mobileNumber,value:mobile_no})
            setUserGender({...UserGender,value:gender})
            setUserCountryCode({...userCountryCode,value:country_code})
            setTshirtSize({...tShirtSize,value:tshirt_size})
            setTargetExam({...targetExam,value:target_exam})
        }

        
    },[userDetail])

    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        let formIsValid = true

        if (!studentName.value) {
            formIsValid = false
            let msg = "Please enter student name"
            setStudentName({ ...studentName, error: msg })
        }
        else if (studentName.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setStudentName({ ...studentName, error: msg })
        }
        else if (studentName.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setStudentName({ ...studentName, error: msg })
        }
        else if (!nameRegex.test(studentName.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setStudentName({ ...studentName, error: msg })
        }

        // Phone number
        if (!mobileNumber.value) {
            formIsValid = false
            let msg = "Please enter your mobile number"
            setMobileNumber({ ...mobileNumber, error: msg })
        }

        if (!mobileRegex.test(mobileNumber.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setMobileNumber({ ...mobileNumber, error: msg })
        }

        
        if(userCountryCode?.value !=='+91'){
            if(country_id ===1 || country_id ===2 || country_id ===4 || country_id ===5){
                if(mobileNumber.value.length < 8){
                    formIsValid = false
                    let msg = "Min 8 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 8){
                    formIsValid = false
                    let msg = "Max 8 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
            }
            else if(country_id ===6){
                if(mobileNumber.value.length < 9){
                    formIsValid = false
                    let msg = "Min 9 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 9){
                    formIsValid = false
                    let msg = "Max 9 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
            }
    
            else if(country_id ===7){
                if(mobileNumber.value.length < 9){
                    formIsValid = false
                    let msg = "Min 9 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
                else if(mobileNumber.value.length > 10){
                    formIsValid = false
                    let msg = "Max 10 Digit Length"
                    setMobileNumber({ ...mobileNumber, error: msg })
                }
            }
        }
        

        if (!userDob.value) {
            formIsValid = false
            let msg = "Please select date of birth"
            setUserDob({ ...userDob, error: msg })
        }

        if (!UserGender.value) {
            formIsValid = false
            let msg = "Please select your gender"
            setUserGender({ ...UserGender, error: msg })
        }

        if(formIsValid){
            setStudentName({...studentName,error:''})
            setUserDob({...userDob,error:''})
            setMobileNumber({...mobileNumber,error:''})
            setUserGender({...UserGender,error:''})
            // setTshirtSize({...tShirtSize,error:''})
            // setTargetExam({...targetExam,error:''})
        }

        return formIsValid;
    }


    const submitFormHandler = async(e) => {
    e.preventDefault();
    if(validation()){
        setLoading(true)
        const data = {
            id:userDetail?.id,
            name:studentName.value,
            email:UserEmail.value,
            dob:userDob.value,
            mobile_no:mobileNumber.value,
            gender:UserGender.value,
            country_code:userCountryCode.value,
            // tshirt_size:tShirtSize.value?.name ||'',
            // target_exam:targetExam.value?.id ||''
        }
        
    
        try {
            await upadateProfileDetail(data).then((res) => {
                if(res.status){
                    setLoading(false)
                    setUserDetail({...userDetail,...res?.data})
                    swal(res?.message,'','success').then(() => {
                        nexTabChange()
                    })
                }
                else{
                    setLoading(false)
                    swal(res?.message,'','error')
                }
            })
        } catch (error) {
            console.log('update profile..',error)
        }
    }
 
    }

    console.log('user country code..',userCountryCode)

  return (

        userDetail ? 
        <form onSubmit={submitFormHandler} className="row mt-3 gx-lg-5">
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Student Full Name<span>*</span></label>
                    <input type="text" disabled={is_paid ===1 || paid_status===1} value={studentName.value}
                     onChange={(e) =>{
                        let value = e.target.value
                        value = value.replace(/[^A-Za-z ]/ig, '')   
                        setStudentName({...studentName,value:value,error:''})
                    }
                    } 
                     className="form-control"  
                     placeholder="Student Name"
                     />
                    {studentName?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{studentName.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Student Email<span>*</span></label>
                    {email ? <input type='email' className="form-control" disabled readOnly value={email}/> 
                    : <input type="email" value={UserEmail.value} disabled readOnly onChange={e => setUserEmail({...UserEmail,value:e.target.value,error:''})} className="form-control"  placeholder="example@gmail.com"/>

                    }

                </div>
            
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Date of Birth<span>*</span></label>
                    <input type="date" max={minDate} value={userDob.value} onChange={e => setUserDob({...userDob,value:e.target.value,error:''})} className="form-control" />
                    {userDob?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{userDob.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        <div className="col-2">
                            <select  className='form-control' value={userCountryCode.value} onChange={(e) => setUserCountryCode({...userCountryCode,value:e.target.value})}  disabled={is_paid ===1 || paid_status===1}>
                                {countryCode?.map((item => (
                                        <option value={item.isd_code} defaultValue={item.isd_code === country_code} key={item.id}>{item.isd_code}</option>
                                )))}
                            </select>
                        </div>
                        <div className="col-10">
                            <input type="text" disabled={is_paid ===1 || paid_status===1} value={mobileNumber.value} onChange={e => setMobileNumber({...mobileNumber,value:e.target.value,error:''})} className="form-control" placeholder="Enter mobile number"/>
                        </div>
                    </div>
                    {mobileNumber?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{mobileNumber.error}</small>}

                </div>

            <div className="col-md-6 mb-3">
                    <label className="form-label">Gender<span>*</span></label>
                    <select className="form-control" value={UserGender.value?.toLowerCase() ||''} onChange={e => setUserGender({...UserGender,value:e.target.value,error:''})}>
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="others">Others</option>
                    </select>
                    {UserGender?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{UserGender.error}</small>}

                </div>

                <div className="col-md-12 mt-2">
                    {loading ? <button className="btn btn-default" disabled type="button">
                            <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                                Updating...</button>:<button type="submit" className="btn btn-default">Save & Next</button>}
                    
                    {/* <button className="btn btn-default ms-2" onClick={e => nexTabChange()} type="button">Next</button> */}
                </div>


        </form>
        : 'loading'
  )
}

export default ProfileInfoForm